// extracted by mini-css-extract-plugin
export default {"loader":"basic-spinner_loader__CN0Nl","spin":"basic-spinner_spin__SGBKG"};